// src/components/MovieList.js
import React from "react";
import MovieCard from "./MovieCard";
import "./MovieList.scss";

const MovieList = ({ movies }) => {
    return (
        <div className="movie_list">
            {movies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
            ))}
        </div>
    );
};

export default MovieList;
